module.exports = __webpack_public_path__ + "static/img/premiere_link_button_img.4f98ee1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/premiere_link_button_img.png
// module id = x8n9
// module chunks = 3